module.exports = require("./te-IN.js");